import { cn, Form, Tooltip } from "@bleu.builders/ui";
import React, { useEffect } from "react";
import { useSWRConfig } from "swr";

export function ToggleFormAction({
  tooltip,
  Icon,
  actionPath,
  defaultSelected,
  tooltipHandlers = {},
  allowMutate = true,
  color = "red",
  className = "",
}) {
  const [animate, setAnimate] = React.useState(false);
  const [select, setSelected] = React.useState(() => defaultSelected);
  const { mutate } = useSWRConfig();

  useEffect(() => {
    setSelected(defaultSelected);
  }, [defaultSelected]);

  function onClick(e) {
    e.stopPropagation();
    setSelected((prev) => !prev);
    setAnimate(true);

    setTimeout(() => {
      setAnimate(false);
      if (allowMutate) {
        mutate(() => true, undefined, {
          revalidate: true,
        });
      }
    }, 1000);
  }

  const colorClasses = {
    red: "hover:text-red-600 fill-red-600",
    gold: "hover:text-gold fill-gold stroke-gold",
  };

  return (
    <Form action={actionPath} method="post" className="flex">
      <button type="submit" onClick={onClick} className="text-center">
        <Tooltip
          content={tooltip}
          className="bg-background text-foreground max-w-xs border border-muted-foreground"
          {...tooltipHandlers}
        >
          <Icon
            className={cn(
              "size-4 hover:scale-105",
              className,
              { [colorClasses[color]]: select },
              { "animate-like-pulse": animate },
            )}
          />
        </Tooltip>
      </button>
    </Form>
  );
}
